import './style.css'
import moment from 'vue-moment'

export default {
  install (Vue) {
    Vue.use(moment)
  }
}



// WEBPACK FOOTER //
// ./~/vue-timetable/index.js